import { createTheme } from "baseui";

export const theme = createTheme({
    primaryFontFamily: 'Overpass',
    primary: '#099804',
}, {})
